var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrofeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round_prize-yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.117338,12.4298885 C26.096906,11.8763307 27.5353182,9.71242298 27.5353182,6.18978251 L27.5353182,5.28396068 L23.9392878,5.28396068 L23.9392878,6.18978251 C23.9392878,8.60530738 23.6310567,10.7188916 23.117338,12.4298885 Z M11.0449504,28.7346815 L18.3397548,28.7346815 L18.3397548,30.4456782 L11.0449504,30.4456782 L11.0449504,28.7346815 Z M8.93870397,26.9230378 L7.85989497,32.3076453 L21.5248103,32.3076453 L20.4460012,26.9230378 L8.93870397,26.9230378 Z M14.6923527,17.1602913 C19.5213077,17.1602913 22.1412727,13.3357103 22.1412727,6.24010594 L22.1412727,1.71099678 L7.29480447,1.71099678 L7.29480447,6.18978251 C7.29480447,13.2350634 9.91476947,17.1602913 14.6923527,17.1602913 Z M6.37011087,12.480212 C5.80502047,10.7188916 5.49678927,8.60530738 5.49678927,6.18978251 L5.49678927,5.28396068 L1.79801518,5.28396068 L1.79801518,6.18978251 C1.79801518,9.76274638 3.28779918,11.9266541 6.37011087,12.480212 Z M23.9392878,3.57296388 L29.3333334,3.57296388 L29.3333334,6.18978251 C29.3333334,10.869862 26.7647402,13.889268 22.398132,14.2415322 C21.0110917,17.0093211 18.6993579,18.5693475 15.6170462,18.8209648 L15.6170462,25.1113941 L21.987157,25.1113941 L23.887916,34.0689655 L5.49678927,34.0689655 L7.39754817,25.1113941 L13.7676591,25.1113941 L13.7676591,18.8209648 C10.7367192,18.5693475 8.47635727,17.0093211 7.08931697,14.2415322 C2.61996498,13.9395915 0,10.9201854 0,6.18978251 L0,3.57296388 L5.49678927,3.57296388 L5.49678927,-4.4408921e-16 L23.9392878,-4.4408921e-16 L23.9392878,3.57296388 Z",
    id: "path-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round_prize-yellow",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-5",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 40,
    cy: 40,
    r: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "colors/yellow-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colors/yellow",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Reassurance/Gaming-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-5)",
    id: "Reassurance/Gaming"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.666666, 24.597701)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors/dark-Clipped",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colors/dark",
    mask: "url(#mask-7)",
    fill: "#1F2532",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.333333, -3.264368)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofeo);
export default __webpack_public_path__ + "static/media/trofeo.0c17c60b1acde7b916f9242b207b1c12.svg";
export { ForwardRef as ReactComponent };